import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const LogoContext = createContext();

export const LogoProvider = ({ children }) => {
    const [logoUrl, setLogoUrl] = useState(null);
    const apiUrl = process.env.REACT_APP_API_URL;
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");

    useEffect(() => {
        const fetchLogo = async () => {
            try {
                const response = await axios.get(`${apiUrl}/api/get_business_logo/`, {
                    headers: {
                        "Content-Type": "application/json",
                    },
                    params: { state: token },
                });
                const logo_filename = response.data.logo_filename;
                setLogoUrl(logo_filename); // Store logo URL from API
            } catch (error) { console.error("Error fetching logo:", error); }
        };
        fetchLogo();
    }, []);

    return (
        <LogoContext.Provider value={logoUrl}>
            {children}
        </LogoContext.Provider>
    );
};

export const useLogo = () => useContext(LogoContext);
